import { useEffect, useState, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import { systemAPI } from '../../apis';
import PreviewDialog from '../PreviewDialog';
import { onKeyUpEnterOrSpace } from '../../utils';

const useStyles = makeStyles((theme) => ({
  img: {
    width: '100%',
    height: 'auto',
    borderRadius: '0.625rem',
    cursor: 'pointer',
  },
}));

const Img = ({ id, type, url, onLoad }) => {
  const classes = useStyles();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isFail, setIsFail] = useState(false);
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const getFileAPI = async (props) => {
    try {
      const { result } = await systemAPI.getSysNotificationFile({ fileIds: props }, { isHideLoading: true });
      setData(result[0]);
      setIsLoading(false);
      onLoad?.();
    } catch (error) {
      setIsLoading(false);
      setIsFail(true);
      console.log('---getFileAPI---', error);
      onLoad?.();
    }
  };
  const handleImgOnClick = () => {
    const notificationImgUrl = `data:${data?.fileType};base64,${data?.fileDesc}`;
    setPreviewUrl(type === 'notification' ? notificationImgUrl : url);
    setShowPreviewDialog(true);
  };

  useEffect(() => {
    if (type === 'notification') {
      (async () => {
        await getFileAPI([id]);
      })();
    }
  }, []);

  const returnImg = () => {
    if (isLoading) {
      return (
        <Box width="100%" height="10rem" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Box>
      );
    } else {
      return isFail ? null : (
        <img
          tabIndex={0}
          onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleImgOnClick)}
          onClick={handleImgOnClick}
          className={classes.img}
          src={`data:${data?.fileType};base64,${data?.fileDesc}`}
          alt="notification_img"
          onLoad={onLoad}
          onError={onLoad}
        />
      );
    }
  };

  return (
    <>
      {type === 'notification' ? (
        returnImg()
      ) : (
        <img
          tabIndex={0}
          onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleImgOnClick)}
          onClick={handleImgOnClick}
          className={classes.img}
          src={url}
          alt="task_img"
          onLoad={onLoad}
          onError={onLoad}
        />
      )}
      <PreviewDialog
        previewUrl={previewUrl}
        showDialog={showPreviewDialog}
        closePop={() => setShowPreviewDialog(false)}
      />
    </>
  );
};

export default memo(Img);
